import { render, staticRenderFns } from "./post-info.vue?vue&type=template&id=c1ec3934&scoped=true&"
import script from "./post-info.vue?vue&type=script&lang=js&"
export * from "./post-info.vue?vue&type=script&lang=js&"
import style0 from "./post-info.vue?vue&type=style&index=0&id=c1ec3934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ec3934",
  null
  
)

export default component.exports